import { SendToOverseerUIMessageHandler } from '@tv2-player/unifiedplayer/src/util/overseer/overseerUIGateway';
import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';
import { OverseerService } from '@tv2-player/unifiedplayer/src/util/overseer/overseerService';
import { devFlags } from '@tv2-player/unifiedplayer/src/util/devFlags';
import { VcrCollector } from '@tv2-player/unifiedplayer/src/util/VcrCollector';
import { PlatformMetadataService } from '@tv2-player/service-types/src/PlatformMetadataService';
import { DatadogLoggerService } from '@tv2-player/datadog-logger';
import { prerollOverrideUrls } from '@tv2-player/unifiedplayer/src/mediaMaking/switchPrerollHost';
import { DatadogLoggerMaxNumberOfLogsWrapper } from '@tv2-player/datadog-logger/src/datadogLoggerMaxNumberOfLogsWrapper';
import { datadogLogs } from '@datadog/browser-logs';
import getEnv from './getEnv';

export function registerPlayerServices() {
  ServiceContainer.reset();

  registerConfiguration();
  registerDatadogLoggerService();
  OverseerService.register();

  SendToOverseerUIMessageHandler.register({
    killOnFailures: false,
    baseApiUrl: ServiceContainer.config.get(devFlags.overseerApiUrl),
  });
  const collector = (e: any) => {
    const { cast } = window as any;
    const context = cast.framework.CastReceiverContext.getInstance();
    context.sendCustomMessage('urn:x-cast:vcr', undefined, e);
  };

  ServiceContainer.register(VcrCollector).instance({
    collect: (event: any, sessionId: string) => {
      collector(event);
    },
  });
  ServiceContainer.register(PlatformMetadataService).instance({
    platform: 'cast',
  });
}

function registerConfiguration() {
  const {
    VITE_ENABLE_OVERSEER,
    VITE_ENABLE_PLAYER_VCR,
    VITE_USE_ACTIVE_TRACKING_NIELSEN,
    VITE_OVERSEER_API_URL,
  } = getEnv();

  ServiceContainer.config.set(
    devFlags.enableOverseer,
    getBooleanQueryParam(devFlags.enableOverseer.name) ?? VITE_ENABLE_OVERSEER
  );

  ServiceContainer.config.set(
    devFlags.enablePlayerVCR,
    getBooleanQueryParam(devFlags.enablePlayerVCR.name) ?? VITE_ENABLE_PLAYER_VCR
  );

  ServiceContainer.config.set(
    devFlags.useActiveTrackingNielsen,
    getBooleanQueryParam(devFlags.useActiveTrackingNielsen.name) ?? VITE_USE_ACTIVE_TRACKING_NIELSEN
  );

  ServiceContainer.config.set(
    devFlags.overseerApiUrl,
    getStringQueryParam(devFlags.overseerApiUrl.name) ?? VITE_OVERSEER_API_URL
  );

  // Test streams are disabled by default
  ServiceContainer.config.set(
    devFlags.enableTestStreams,
    getBooleanQueryParam(devFlags.enableTestStreams.name) ?? false
  );
  ServiceContainer.config.set(
    devFlags.testStream,
    getStringQueryParam(devFlags.testStream.name) ?? 'Looping LAR - Normal'
  );

  ServiceContainer.config.set(
    devFlags.enablePrerollOverride,
    getBooleanQueryParam(devFlags.enablePrerollOverride.name) ?? false
  );
  ServiceContainer.config.set(
    devFlags.prerollOverrideUrl,
    getStringQueryParam(devFlags.prerollOverrideUrl.name) ?? prerollOverrideUrls.dev
  );
}

function registerDatadogLoggerService() {
  ServiceContainer.addInstance(new DatadogLoggerMaxNumberOfLogsWrapper(datadogLogs.logger)).as(
    DatadogLoggerService
  );
}
function getBooleanQueryParam(paramName: string) {
  const searchParams = new URLSearchParams(new URL(window.location.href).search);
  const paramValue = searchParams.get(paramName);
  return paramValue == null ? null : paramValue === 'true';
}
function getStringQueryParam(paramName: string) {
  const searchParams = new URLSearchParams(new URL(window.location.href).search);
  const paramValue = searchParams.get(paramName);
  return paramValue ? JSON.parse(paramValue) : null;
}
